import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const developerChildRoutes: PermissionedRouteObject[] = [
  {
    path: "functions",
    handle: { breadcrumb: "Functions" },
    async lazy() {
      const { FunctionsListPage } =
        await import("./functions/functions-list-page");
      return { Component: FunctionsListPage };
    },
  },
  {
    path: "logs",
    handle: { breadcrumb: "Logs" },
    async lazy() {
      const { FunctionLogsPage } = await import("./logs/function-logs-page");
      return { Component: FunctionLogsPage };
    },
  },
];
